import Vue from 'vue';
import Router from 'vue-router';
import { isEmpty } from 'lodash';
import Home from './views/Home.vue';
import Login from './views/Login.vue';
import TokenLogin from './views/TokenLogin.vue';
import LoginCallback from './views/LoginCallback.vue'
import auth from './auth';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      // This is for sso failure cases
      props: route => ({ externalMessage: route.query.message || '' }),
      meta: {
        loginLayout: true,
        hidden: true,
        title: 'Login',
        resetStack: true,
      },
      component: Login,
    },
    // token-login route receives JWT token from backend
    // and just forwards to another page
    {
      path: '/token-login/:token',
      name: 'tokenlogin',
      props: true,
      meta: {
        loginLayout: true,
        hidden: true,
        title: 'Token login',
        resetStack: true,
      },
      component: TokenLogin,
    },
    {
      path: '/keycloak/login-callback',
      name: 'keycloak-login-callback',
      // This is for sso failure cases
      meta: {
        loginLayout: true,
        hidden: true,
        title: 'Login Callback',
        resetStack: true,
      },
      component: LoginCallback,
    },
    {
      path: '/',
      name: 'home',
      icon: 'home',
      meta: {
        title: 'Home',
        resetStack: true,
      },
      component: Home,
    },
    {
      path: '/search',
      name: 'search',
      icon: 'search',
      meta: {
        title: 'Search media',
        resetStack: true,
      },
      component: () => import('./views/Search.vue'),
    },
    {
      path: '/media-package/:id',
      name: 'media-package',
      props: true,
      meta: {
        hidden: true,
        title: 'Media package',
      },
      component: () => import('./views/MediaPackage.vue'),
    },
    {
      path: '/media-basket',
      name: 'media-basket',
      meta: {
        hidden: true,
        title: 'Media basket',
        resetStack: true,
      },
      component: () => import('./views/MediaBasket.vue'),
    },
    {
      path: '/admin/home',
      name: 'admin-home',
      meta: {
        title: 'Admin',
        hidden: true,
        resetStack: true,
      },
      component: () => import('./views/admin/AdminHome.vue'),
    },
    {
      path: '/admin/usergroup/:id',
      name: 'admin-usergroup',
      props: true,
      meta: {
        title: 'Admin - User Group',
        hidden: true,
      },
      component: () => import('./views/admin/AdminUserGroup.vue'),
    },
    {
      path: '/admin/user/:username',
      name: 'admin-user',
      props: true,
      meta: {
        title: 'Admin - User',
        hidden: true,
      },
      component: () => import('./views/admin/AdminUser.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && to.name !== 'tokenlogin' && to.name !== 'keycloak-login-callback') {
    if (auth.isAuthenticated()) {
      if (isEmpty(store.state.typeDefs) && isEmpty(store.state.user) && isEmpty(store.state.layeringSettings)) {
        store.dispatch('init').then(() => {
          next();
        }).catch(() => {
          next('/');
        });
      } else {
        next();
      }
    } else {
      if (router.app.$keycloak?.authenticated) {
        next('/keycloak/login-callback')
      } else {
        next('/login');
      }
    }
  } else {
    if (to.name === 'login' && auth.isAuthenticated()) {
      // If user is already authenticated, redirect to home page when trying to access login page...
      next('/')
    } else {
      next();
    }
  }
});

router.afterEach((to) => {
  if (to.meta && to.meta.resetStack) {
    // if clicked from main menu, reset stack
    store.dispatch('replaceStack', to);
  } else if (store.getters.previousStackItem && store.getters.previousStackItem.fullPath === to.fullPath) {
    store.dispatch('removeLastFromStack');
  } else {
    store.dispatch('addToStack', to);
  }
});

export default router;
